// Dynamic styles based on theme - to be used with useThemedStyles.
// Shared by the lead detail screen, its contact blocks and text actions.
export const createLeadDetailStyles = ({ ui: { colors, type, space, touch } }) => ({
	hero: {
		backgroundColor: colors.current,
		borderColor: colors.currentBorder,
	},
	kicker: {
		...type.overline,
		color: colors.currentSubtle,
		marginBottom: space.xs,
	},
	title: {
		...type.title,
		color: colors.text,
	},
	heroMetaRow: {
		marginTop: space.sm,
		gap: 2,
	},
	heroMeta: {
		...type.secondary,
		color: colors.currentSubtle,
	},
	sectionTitle: {
		marginBottom: 14,
	},
	field: {
		marginBottom: space.lg,
	},
	fieldLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: 6,
	},
	readOnlyValue: {
		...type.bodySmall,
		color: colors.text,
	},
	selectorButton: {
		width: '100%',
	},
	textAction: {
		alignSelf: 'flex-start',
		minHeight: touch.min,
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.sm,
	},
	pressed: {
		opacity: 0.7,
	},
	textActionLabel: {
		...type.bodySmallStrong,
		color: colors.accent,
		flexShrink: 1,
	},
	fieldHint: {
		...type.caption,
		color: colors.textSecondary,
		marginTop: space.sm,
	},
	lastContact: {
		borderTopWidth: 1,
		borderTopColor: colors.border,
		paddingTop: 14,
	},
	contactFormLabel: {
		marginBottom: space.md,
	},
	contactFormActions: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		gap: space.sm,
		marginTop: 10,
	},
	contactFormButton: {
		minWidth: 96,
	},
	contactBlock: {
		paddingBottom: 14,
		marginBottom: 14,
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
	},
	// The last contact sits at the bottom of its card, so it needs no divider.
	contactBlockLast: {
		paddingBottom: 0,
		marginBottom: 0,
		borderBottomWidth: 0,
	},
	contactLabel: {
		...type.overline,
		color: colors.textSecondary,
		marginBottom: space.xs,
	},
	contactName: {
		...type.rowTitleSemibold,
		color: colors.text,
	},
	contactRole: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: 2,
	},
	enquiryMeta: {
		...type.secondarySemibold,
		color: colors.textSecondary,
		marginBottom: 10,
	},
	enquiryText: {
		...type.bodySmall,
		color: colors.text,
	},
	noteComposer: {
		gap: space.sm,
		paddingBottom: space.lg,
		marginBottom: space.xs,
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
	},
	noteInput: {
		minHeight: 108,
	},
	addPhotosButton: {
		marginTop: space.sm,
	},
	note: {
		paddingVertical: 13,
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
	},
	noteLast: {
		paddingBottom: 0,
		borderBottomWidth: 0,
	},
	noteText: {
		...type.bodySmall,
		color: colors.text,
	},
	noteMeta: {
		...type.caption,
		color: colors.textSecondary,
		marginTop: 6,
	},
	emptyText: {
		...type.secondary,
		color: colors.textSecondary,
	},
});
